import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { registerUser } from '../store/actions/userAction'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Navigation from '../public/NavbarHomepage'
import ContactForm from '../public/ContactForm'
import { withTranslation } from 'react-i18next'
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CountryDropdown } from 'react-country-region-selector';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  containerNavbar: {
    [theme.breakpoints.down("sm")]: {
        background: '#191919', 
        padding: '0 25px'
    },
    [theme.breakpoints.up("sm")]: {
        background: '#191919', 
        padding: '0 64px'
    },
  },
  paper: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "rgb(26, 26, 26)",
    color: "white",
    borderRadius: "3px",
    textAlign: "center"
  },
  divider: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    }
  },
  imageLogin: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    }
  },
  txtLogin: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
      marginTop: "1.5rem"
    },
  },
  containerTop: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "-3rem",
      marginBottom: "-3rem",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0",
    },
  },
}));

const Register = ({ t }) => {
    const classes = useStyles();
    const [ input, setInput ] = useState({
      email: '',
      password: ''
    })
    const history = useHistory()
    const dispatch = useDispatch()


    const handleChange = (e) => {
        let { name, value } = e.target
        setInput({ ...input, [name]: value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(registerUser(input))
        history.push('/login')
    }

    const handleLogin = (e) => {
      history.push('/login')
    }

    const gotoHomePage = () => {
      history.push('/')    
    }

    const [lang, setLang] = useState('')

    const setLocale = (locale) => {
      setLang(locale)
    }

    const [open, setOpen] = useState(false);

    const [values, setValues] = useState({
      password: '',
      showPassword: false,
    });

    const handleClickShowPassword = () => {
      setValues({ ...values, showPassword: !values.showPassword });
    };
  
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    const handleChangePassword = (prop) => (e) => {
      setValues({ ...values, [prop]: e.target.value });
      let { name, value } = e.target
      setInput({ ...input, [name]: value })
    };

    const [state, setState] = useState({
      country: ""
    });

    const selectCountry = (val) => {
      setState({ ...state, country: val });
    };

    const { country } = state;

    const handleChangeCheck = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
    };

    const BlackCheckbox = withStyles({
      root: {
        color: '#2b2b2b',
        padding: "3px 3px 3px 10px",
        '&$checked': {
          color: '#2b2b2b',
          padding: "3px 3px 3px 10px",
        },
      },
      checked: {},
    })((props) => <Checkbox color="default" {...props} />);

    return (
      <>
        <Container className={classes.containerNavbar} maxWidth="xl">
          <Navigation locale={setLocale}/>
        </Container>
        <Container className="signUpPage py-5 mb-5" component="main" maxWidth="md">
        <Grid className={classes.containerTop} container direction="row" alignItems="center">
          <Grid xs={12} md={5}>
            <div className={classes.paper}>
              <p className="bold font-size-20 mb-1">
                {t('register.signUp')}
              </p>
              <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={6} md={6} className="text-center">
                    <TextField
                      variant="outlined"
                      margin="dense"
                      size="small"
                      required
                      fullWidth
                      id="firstName"
                      placeholder={t('register.firstName')}
                      name="firstName"
                      autoFocus
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={6} md={6} className="text-center">
                    <TextField
                      variant="outlined"
                      margin="dense"
                      size="small"
                      required
                      fullWidth
                      id="lastName"
                      placeholder={t('register.lastName')}
                      name="lastName"
                      autoFocus
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <TextField
                  variant="outlined"
                  margin="dense"
                  size="small"
                  required
                  fullWidth
                  id="email"
                  placeholder={t('register.username')}
                  name="email"
                  autoFocus
                  onChange={handleChange}
                />
                <TextField
                  variant="outlined"
                  margin="dense"
                  size="small"
                  placeholder={t('login.password')}
                  required
                  fullWidth
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password}
                  name="password"
                  onChange={handleChangePassword('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {values.showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <CountryDropdown
                value={country}
                onChange={(val) => selectCountry(val)}
                defaultOptionLabel={t('register.country')}
                style={{
                  fontSize: 16,
                  padding: "10px",
                  width: "100%",
                  borderRadius: "5px",
                  margin: "8px 0 3px 0",
                  borderColor: "#bbbbbb",
                  color: "#5a5a5a"
                }} />
                <TextField
                  variant="outlined"
                  margin="dense"
                  size="small"
                  required
                  fullWidth
                  id="company"
                  placeholder={t('register.company')}
                  name="company"
                  autoFocus
                  onChange={handleChange}
                />
                <FormControlLabel
                  className="font-size-14"
                  control={<BlackCheckbox checked={state.checkedG} onChange={handleChangeCheck} name="checkedG" />}
                  label={t('register.check')}
                  size="small"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.submit}
                >
                  {t('register.signUp')}
                </Button>
                <Grid container alignItems="center">
                  <Grid item xs={12} md={12} className="text-center mt-2">
                    <span className="font-size-14">{t('register.loginTxt')}&thinsp;</span>
                    <Link href="#" className="bold font-size-14" onClick={handleLogin}>
                      {t('login.login')}
                    </Link>
                  </Grid>
                </Grid>
              </form>
            </div>
          </Grid> 
          <Grid xs={12} md={2}>
            <div className="m-auto text-center w-100">
              <img className={classes.divider} src="/divider-login.png" alt="divider-login" width="9%"/>
            </div>
          </Grid>
          <Grid xs={12} md={5}>
          <div className="d-flex align-items-center" style={{ flexDirection : "column" }}>
            <img className={classes.imageLogin} src="/login-image.png" alt="login-image" width="100%"/>
            <p className={classes.txtLogin}>
              {t('content.tagline')}
            </p>
          </div>
        </Grid>
        </Grid>
        </Container>
        <div>
          <ContactForm/>
        </div>
      </>
    )
}

export default withTranslation()(Register)
